module.exports = __webpack_public_path__ + "img/emerging power.74b06921.png";